(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-add')) {
    customElements.define('quick-add', class extends HTMLElement {
      constructor() {
        super();
        this.collapseTimer = null;
      }

      connectedCallback() {
        this.trigger = this.querySelector('[data-quick-add-trigger]');
        this.panel = this.querySelector('[data-quick-add-panel]');
        this.qtyInput = this.querySelector('[data-quick-add-qty]');
        this.submitBtn = this.querySelector('[data-quick-add-submit]');

        if (!this.trigger || !this.panel) return;

        this.trigger.addEventListener('click', this.expand.bind(this));
        this.querySelectorAll('[data-quick-add-step]').forEach((b) => {
          b.addEventListener('click', this.step.bind(this));
        });
        this.submitBtn.addEventListener('click', this.submit.bind(this));

        this.addEventListener('click', (e) => e.stopPropagation());

        this.outsideHandler = (e) => {
          if (!this.contains(e.target)) this.collapse();
        };
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.outsideHandler);
        clearTimeout(this.collapseTimer);
      }

      expand() {
        this.trigger.hidden = true;
        this.panel.hidden = false;
        this.qtyInput?.focus();
        this.qtyInput?.select();
        document.addEventListener('click', this.outsideHandler);
        this.resetCollapseTimer();
      }

      collapse() {
        this.trigger.hidden = false;
        this.panel.hidden = true;
        if (this.qtyInput) this.qtyInput.value = 1;
        document.removeEventListener('click', this.outsideHandler);
        clearTimeout(this.collapseTimer);
      }

      resetCollapseTimer() {
        clearTimeout(this.collapseTimer);
        this.collapseTimer = setTimeout(() => this.collapse(), 5000);
      }

      step(e) {
        const delta = parseInt(e.currentTarget.dataset.quickAddStep, 10);
        const current = parseInt(this.qtyInput.value, 10) || 1;
        this.qtyInput.value = Math.max(1, current + delta);
        this.resetCollapseTimer();
      }

      async submit() {
        const qty = parseInt(this.qtyInput.value, 10) || 1;
        const variantId = this.dataset.variantId;
        const sku = this.dataset.sku;

        this.submitBtn.setAttribute('data-loading', '');
        clearTimeout(this.collapseTimer);

        try {
          if (window.SparkLayer?.cart?.add) {
            await window.SparkLayer.cart.add({
              variantId,
              sku,
              quantity: qty,
            });
          } else {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
            });
            if (!res.ok) throw new Error('Cart add failed');
          }

          this.setAttribute('data-success', '');
          this.submitBtn.querySelector('.quick-add__submit-label').textContent = '✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          setTimeout(() => {
            this.removeAttribute('data-success');
            this.submitBtn.querySelector('.quick-add__submit-label').textContent = 'Add';
            this.collapse();
          }, 1200);
        } catch (err) {
          console.error('[quick-add]', err);
          this.submitBtn.querySelector('.quick-add__submit-label').textContent = '!';
          setTimeout(() => {
            this.submitBtn.querySelector('.quick-add__submit-label').textContent = 'Add';
          }, 1500);
        } finally {
          this.submitBtn.removeAttribute('data-loading');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
